var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center margin-top"},[_c('button',{staticClass:"btn btn-sm mx-auto btn-primary btn-responsive",attrs:{"disabled":_vm.disabled || _vm.loading,"type":"submit"}},[(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f97aec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Users/LoginOrSignup/SubmitButton.vue
// module id = 899
// module chunks = 1 2